"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPersonalizationType = void 0;
var IPersonalizationType;
(function (IPersonalizationType) {
    IPersonalizationType["Speed"] = "Speed";
    IPersonalizationType["Endurance"] = "Endurance";
    IPersonalizationType["Agility"] = "Agility";
    IPersonalizationType["HillClimbing"] = "Hill Climbing";
})(IPersonalizationType || (exports.IPersonalizationType = IPersonalizationType = {}));
//# sourceMappingURL=personalization-type.js.map